/**
 * LOT-SW-REPOS — branchement RÉEL de la mise à jour du service worker.
 *
 * Ce fichier est volontairement MINCE : il importe le module virtuel de
 * vite-plugin-pwa (qui n'existe que sous Vite — vitest ne le résout pas) et
 * passe les vraies dépendances au cœur testable (`swUpdate.ts`). Toute la
 * logique de décision (repos, différé, anti-boucle, vérification périodique)
 * vit là-bas ; ici, rien à tester, rien à mocker.
 *
 * `main.staleChunkReload.spec.ts` importe `main.tsx` : il double ce module
 * (`vi.mock('./pwa/registerServiceWorker')`) précisément parce que le module
 * virtuel n'est pas résoluble hors Vite.
 */
import { registerSW } from 'virtual:pwa-register'
import { callMachine } from '../telephony/callMachine'
import { installServiceWorkerUpdates, type SwUpdateHandle } from './swUpdate'

export function registerServiceWorker(): SwUpdateHandle | undefined {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return undefined

  return installServiceWorkerUpdates({
    registerSW,
    machine: callMachine,
    currentBuildId: __BUILD_ID__,
    doc: document,
    win: window,
    storage: sessionStorage,
    serviceWorkerContainer: navigator.serviceWorker,
  })
}
